import moment from 'moment';
import { TimeUnit } from './timeUnit';

export const getTimeUnitFromEpochMs = (value: string) => {
  const createdAtMs = parseInt(value, 10);

  if (moment.utc(value).isValid() || !moment(createdAtMs).isValid()) {
    return {
      value: 0,
      type: TimeUnit.Error,
    };
  }

  const nowMs = Date.now();
  const diffMs = nowMs - createdAtMs;
  const minutesAgo = diffMs / (1000 * 60);

  if (minutesAgo < 1) {
    return {
      value: 0,
      type: TimeUnit.Now,
    };
  }
  if (minutesAgo < 60) {
    return {
      value: Math.floor(minutesAgo),
      type: TimeUnit.Minutes,
    };
  }

  const hoursAgo = diffMs / (1000 * (60 * 60));
  if (hoursAgo < 24) {
    return {
      value: Math.floor(hoursAgo),
      type: TimeUnit.Hours,
    };
  }

  const daysAgo = diffMs / (1000 * (60 * 60 * 24));

  if (daysAgo < 30) {
    return {
      value: Math.floor(daysAgo),
      type: TimeUnit.Days,
    };
  }

  const now = new Date();
  const past = new Date(createdAtMs);

  const yearsDiff = now.getFullYear() - past.getFullYear();
  const monthsDiff = now.getMonth() - past.getMonth();
  const monthsAgo = yearsDiff * 12 + monthsDiff;

  if (monthsAgo < 12) {
    return {
      value: Math.floor(monthsAgo),
      type: TimeUnit.Months,
    };
  }

  const yearsAgo = monthsAgo / 12;

  return {
    value: Math.floor(yearsAgo),
    type: TimeUnit.Years,
  };
};

export default {
  getTimeUnitFromEpochMs,
};
